// ////with search reset button
import React, { useState, useEffect } from "react";
import { Card, CardBody, Col, Button, Spinner, Input, Row } from "reactstrap";
import DataTable from "react-data-table-component";
import { CustomerTitle, ViewCustomerTitle } from "../../../Utils/Constants";
import Breadcrumbs from "../../../CommonElements/Breadcrumbs";
import axios from "axios";
import { baseUrl } from "../../../Utils/FileUpload";
import FilterComponent from "../../../Components/Tables/DataTables/Common/FilterComponent";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import { Video } from "react-feather";

interface Customer {
  id: string;
  mobile: number;
  is_active: number;
  amount: string;
  total_package_amount: string;
  currency: string;
  amount_spent: string;
  amount_without_currency: string;
  total_package_amount_without_currency: string;
  amount_spent_without_currency: string;
}

export default function Customer() {
  const [filterText, setFilterText] = useState("");
  const [filteredItems, setFilteredItems] = useState<Customer[]>([]);
  const token = localStorage.getItem("token");
  const navigate = useNavigate();
  const [totalRows, setTotalRows] = useState<number>(0);
  const [perPage, setPerPage] = useState<number>(10);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [loading, setLoading] = useState(true);
  const [prevPageBeforeSearch, setPrevPageBeforeSearch] = useState<number>(1);
  const [disabledEnable, setDisabledEnable] = useState<string | null>(null);
  const [disableAllEnable, setDisableAllEnable] = useState(false);
  const [refresh, setRefresh] = useState(0);
  const fetchData = async (page = 1, perPage = 10) => {
    if (filterText.trim() === "") {
      try {
        setLoading(true);
        const response = await axios.get(`${baseUrl}customer_detail/getall`, {
          params: {
            page,
            per_page: perPage,
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        const data: Customer[] = response.data.data;
        // console.log(response.data.data, "hh");
        setFilteredItems(data);
        setTotalRows(response.data.total);
        setCurrentPage(response.data.current_page);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    }
  };
  const fetchAllCustomerDataWithoutPagination = async () => {
    try {
      const response = await axios.get(
        `${baseUrl}customer_detail/getallnopagination`,
        {
          params: {
            search: filterText.trim() !== "" ? filterText : undefined,
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const data = response.data.data;
      setFilteredItems(data);
      setTotalRows(response.data.total);
      setCurrentPage(response.data.current_page);
    } catch (error) {
      console.error(
        "Error fetching all customer data without pagination:",
        error
      );
      return []; // return empty array on error
    }
  };
  useEffect(() => {
    if (filterText.trim() === "") {
      fetchData(prevPageBeforeSearch, perPage); // Go back to original page
      setCurrentPage(prevPageBeforeSearch); // Sync UI page
    }
  }, [filterText]);
  useEffect(() => {
    if (filterText.trim() === "") {
      fetchData(currentPage, perPage);
    }
  }, [currentPage, perPage, refresh]);

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
    fetchData(page, perPage); // pass search even when paginating after search
  };

  const handlePerRowsChange = async (newPerPage: number, page: number) => {
    setPerPage(newPerPage);
    setCurrentPage(1);
    fetchData(1, newPerPage);
  };

  const handlePackageHistory = (id: string) => {
    navigate("/package_bought", { state: { id: id } });
  };

  const handlecustomerhistory = (id: string) => {
    navigate("/call_history", { state: { customer_id: id } });
  };

   const handlecustomervideohistory = (id: string) => {
    navigate("/video_call_history", { state: { customer_id: id } });
  };
  const handleSearchClick = () => {
    fetchAllCustomerDataWithoutPagination();
  };

  const handleReset = () => {
    setFilterText("");
    setCurrentPage(prevPageBeforeSearch); // restore to the previous page
    fetchData(prevPageBeforeSearch, perPage); // fetch without search
  };

  const toggleEnable = (id: string, currentStatus: number) => {
    setDisabledEnable(id);
    setDisableAllEnable(true);

    const confirmToggleEnable = async (id: string, currentStatus: number) => {
      setDisabledEnable(null);
      setDisableAllEnable(false);

      try {
        const newStatus = currentStatus === 1 ? 0 : 1;

        await axios.post(
          `${baseUrl}customer_detail/toggle_active`,
          { id, is_active: newStatus },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );

        toast.success(
          `Customer ${newStatus === 1 ? "enabled" : "disabled"} successfully!`,
          {
            position: "top-right",
            autoClose: 1000,
            closeOnClick: true,
            onClose: () => {
              setRefresh((prev) => prev + 1);
            },
          }
        );
      } catch (error) {
        console.error("Error toggling customer:", error);
        toast.error("Error updating enable status", {
          position: "top-right",
          autoClose: 1000,
        });
      }
    };

    // ✅ Use function-based content for toast
    toast.warn(
      ({ closeToast }) => (
        <div>
          <div>
            Are you sure you want to{" "}
            <strong>{currentStatus === 1 ? "disable" : "enable"}</strong> this
            customer?
          </div>
          <div className="d-flex justify-content-end mt-2">
            <Button
              color={currentStatus === 1 ? "danger" : "success"}
              onClick={() => {
                confirmToggleEnable(id, currentStatus);
                closeToast();
              }}
            >
              Yes
            </Button>
            <Button
              color="secondary"
              onClick={() => {
                setDisabledEnable(null);
                setDisableAllEnable(false);
                closeToast();
              }}
              className="ms-2"
            >
              Cancel
            </Button>
          </div>
        </div>
      ),
      {
        position: "top-right",
        autoClose: false,
        closeOnClick: false,
        closeButton: false,
        draggable: false,
        onClose: () => {
          setDisabledEnable(null);
          setDisableAllEnable(false);
        },
      }
    );
  };

  const customerTableColumns = [
    {
      name: "S.No",
      cell: (row: Customer, index: number) => (
        <>{(currentPage - 1) * perPage + index + 1}</>
      ),
      width: "10%",
    },
    {
      name: "Customer Mobile",
      selector: (row: Customer) => row.mobile || "N/A",
      width: "15%",
    },
    {
      name: "Total Purchase Amount",
      selector: (row: Customer) => `${row.total_package_amount}`,
      width: "20%",
    },
    {
      name: "Amount Spent",
      selector: (row: Customer) => `${row.amount_spent}`,
      width: "15%",
    },
    {
      name: "Current Balance",
      selector: (row: Customer) => `${row.amount}`,
      width: "15%",
    },
    {
      name: "Status",
      cell: (row: Customer) => (
        <span
          className={`badge rounded-pill ${
            row.is_active === 1 ? "bg-success" : "bg-danger"
          }`}
        >
          {row.is_active === 1 ? "Enable" : "Disable"}
        </span>
      ),
      width: "10%",
    },
    {
      name: "Actions",
      cell: (row: Customer) => (
        <div className="d-flex justify-content-between">
          <Button
            color={row.is_active ? "success" : "secondary"}
            size="sm"
            onClick={() => toggleEnable(row.id, row.is_active)}
            disabled={disabledEnable === row.id || disableAllEnable}
            style={{
              marginRight: "5px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
            title={row.is_active ? "Disable" : "Enable"}
          >
            <i
              className={`fa ${row.is_active ? "fa-check-circle" : "fa-ban"}`}
            />
          </Button>
          <Button
            color="info"
            size="sm"
            onClick={() => handlecustomerhistory(row.id)}
            style={{
              marginRight: "5px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
            title="Call History"
          >
            <i className="fa fa-phone" />
          </Button>
          <Button
            color="secondary"
            size="sm"
            onClick={() => handlePackageHistory(row.id)} // Call your handler for package history
            style={{
              marginRight: "5px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
            title="Package Bought"
          >
            <i className="fa fa-cube" /> {/* Icon for the button */}
          </Button>
          <Button
            color="teal"
            size="sm"
            onClick={() => handlecustomervideohistory(row.id)}
            style={{
              marginRight: "5px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "#20c997", // custom teal
              borderColor: "#20c997",
            }}
            title="Video Call History"
          >
            <Video size={14} />
          </Button>
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      // button: true,
      width: "15%",
    },
  ];

  const customStyles = {
    headCells: {
      style: {
        fontSize: "16px",
        fontWeight: "600",
        color: "#308e87",
        backgroundColor: "#f8f9fa",
        borderBottom: "2px solid #308e87",
      },
    },
    rows: {
      style: {
        borderBottom: "1px solid #dee2e6",
      },
    },
    table: {
      style: {
        border: "1px solid #dee2e6",
        borderRadius: "8px",
      },
    },
  };

  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <Spinner color="primary" />
      </div>
    );
  }

  return (
    <>
      <div className="page-body">
        <Breadcrumbs
          pageTitle="View Customer"
          parent="Customer"
          title="View Customer"
        />
        <Col xl={12} className="mb-lg-3">
          <Card>
            <CardBody>
              <Row className="align-items-center justify-content-end">
                <Col xl={4}>
                  <div className="mb-3 d-flex align-items-center">
                    <Input
                      type="text"
                      placeholder="Search"
                      value={filterText}
                      onChange={(e) => setFilterText(e.target.value)}
                      className="me-2"
                    />
                    <Button
                      color="primary"
                      onClick={handleSearchClick}
                      className="me-2"
                      title="Search"
                    >
                      <i className="fa fa-search" />
                    </Button>
                    <Button
                      color="danger"
                      onClick={() => handleReset()}
                      title="Reset Search"
                    >
                      <i className="fa fa-refresh" />
                    </Button>
                  </div>
                </Col>
              </Row>

              <div className="table-responsive custom-scrollbar">
                <DataTable
                  data={filteredItems}
                  columns={customerTableColumns}
                  highlightOnHover
                  striped
                  customStyles={customStyles}
                  pagination
                  paginationServer
                  paginationPerPage={perPage}
                  paginationTotalRows={totalRows}
                  onChangePage={handlePageChange}
                  onChangeRowsPerPage={handlePerRowsChange}
                  paginationDefaultPage={currentPage}
                  responsive
                />
              </div>
            </CardBody>
          </Card>
        </Col>
        <ToastContainer />
      </div>
    </>
  );
}

// //seperate function for pagination and search
// import React, { useState, useEffect } from "react";
// import { Card, CardBody, Col, Button, Spinner } from "reactstrap";
// import DataTable from "react-data-table-component";
// import { CustomerTitle, ViewCustomerTitle } from "../../../Utils/Constants";
// import Breadcrumbs from "../../../CommonElements/Breadcrumbs";
// import axios from "axios";
// import { baseUrl } from "../../../Utils/FileUpload";
// import FilterComponent from "../../../Components/Tables/DataTables/Common/FilterComponent";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import { useNavigate } from "react-router-dom";

// interface Customer {
//   id: string;
//   mobile: number;
//   is_active: number;
//   credit: number;
// }

// export default function Customer() {
//   const [filterText, setFilterText] = useState("");
//   const [allData, setAllData] = useState<Customer[]>([]); // Store all data
//   const [filteredItems, setFilteredItems] = useState<Customer[]>([]);
//   const token = localStorage.getItem("token");
//   const navigate = useNavigate();
//   const [totalRows, setTotalRows] = useState<number>(0);
//   const [perPage, setPerPage] = useState<number>(10);
//   const [currentPage, setCurrentPage] = useState<number>(1);
//   const [loading, setLoading] = useState(true);
// const [disabledEnable, setDisabledEnable] = useState<string | null>(null);
// const [disableAllEnable, setDisableAllEnable] = useState(false);
// const [refresh, setRefresh] = useState(0);
//   const fetchData = async (page = 1, perPage = 10) => {
//     try {
//       setLoading(true);
//       const response = await axios.get(`${baseUrl}customer_detail/getall`, {
//         params: {
//           page,
//           per_page: perPage,
//         },
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       });

//       const data: Customer[] = response.data.data;
//       setFilteredItems(data);
//       setTotalRows(response.data.total);
//       setCurrentPage(response.data.current_page);
//       setLoading(false);
//     } catch (error) {
//       console.error("Error fetching data:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const fetchAllData = async () => {
//     try {
//       setLoading(true);
//       const response = await axios.get(`${baseUrl}customer_detail/getall_without_pagination`, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       });

//       const data: Customer[] = response.data.data;
//       setAllData(data); // Store all data for filtering
//       setFilteredItems(data); // Set filtered items to all data initially
//       setTotalRows(data.length); // Set total rows to the length of all data
//       setLoading(false);
//     } catch (error) {
//       console.error("Error fetching all data:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchAllData(); // Fetch all data when the component mounts
//   }, []);

//   useEffect(() => {
//     if (filterText.trim() === "") {
//       fetchData(currentPage, perPage); // Fetch paginated data when search is empty
//     } else {
//       // Filter from the allData state
//       const filteredData = allData.filter((item) => {
//         return (
//           (item.mobile && item.mobile.toString().includes(filterText.toLowerCase())) ||
//           (item.credit && item.credit.toString().includes(filterText.toLowerCase()))
//         );
//       });
//       setFilteredItems(filteredData);
//       setTotalRows(filteredData.length); // Update total rows based on filtered data
//     }
//   }, [filterText, allData, currentPage, perPage]);

//   const handlePageChange = (page: number) => {
//     setCurrentPage(page);
//   };

//   const handlePerRowsChange = async (newPerPage: number, page: number) => {
//     setPerPage(newPerPage);
//     setCurrentPage(1);
//     await fetchData(1, newPerPage);
//   };

//   const handlePackageHistory = (id: string) => {
//     navigate("/package_bought", { state: { id: id } });
//   };

//   const handlecustomerhistory = (id: string) => {
//     navigate("/call_history", { state: { customer_id: id } });
//   };
// const toggleEnable = (id: string, currentStatus: number) => {
//   setDisabledEnable(id);
//   setDisableAllEnable(true);

//   const confirmToggleEnable = async (id: string, currentStatus: number) => {
//     setDisabledEnable(null);
//     setDisableAllEnable(false);

//     try {
//       const newStatus = currentStatus === 1 ? 0 : 1;

//       await axios.post(
//         `${baseUrl}customer_detail/toggle_active`,
//         { id, is_active: newStatus },
//         {
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${token}`,
//           },
//         }
//       );

//       toast.success(
//         `Customer ${newStatus === 1 ? "enabled" : "disabled"} successfully!`,
//         {
//           position: "top-right",
//           autoClose: 1000,
//           closeOnClick: true,
//           onClose: () => {
//             setRefresh((prev) => prev + 1);
//           },
//         }
//       );
//     } catch (error) {
//       console.error("Error toggling customer:", error);
//       toast.error("Error updating enable status", {
//         position: "top-right",
//         autoClose: 1000,
//       });
//     }
//   };

//   // ✅ Use function-based content for toast
//   toast.warn(
//     ({ closeToast }) => (
//       <div>
//         <div>
//           Are you sure you want to{" "}
//           <strong>{currentStatus === 1 ? "disable" : "enable"}</strong> this
//           customer?
//         </div>
//         <div className="d-flex justify-content-end mt-2">
//           <Button
//             color={currentStatus === 1 ? "danger" : "success"}
//             onClick={() => {
//               confirmToggleEnable(id, currentStatus);
//               closeToast();
//             }}
//           >
//             Yes
//           </Button>
//           <Button
//             color="secondary"
//             onClick={() => {
//               setDisabledEnable(null);
//               setDisableAllEnable(false);
//               closeToast();
//             }}
//             className="ms-2"
//           >
//             Cancel
//           </Button>
//         </div>
//       </div>
//     ),
//     {
//       position: "top-right",
//       autoClose: false,
//       closeOnClick: false,
//       closeButton: false,
//       draggable: false,
//       onClose: () => {
//         setDisabledEnable(null);
//         setDisableAllEnable(false);
//       },
//     }
//   );
// };
//   const customerTableColumns = [
//     {
//       name: "S.No",
//       cell: (row: Customer, index: number) => (
//         <>{(currentPage - 1) * perPage + index + 1}</>
//       ),
//       width: "20%",
//     },
//     {
//       name: "Customer Mobile",
//       selector: (row: Customer) => row.mobile || "N/A",
//       sortable: true,
//       width: "20%",
//     },
//     {
//       name: "Credit Remaining",
//       selector: (row: Customer) => row.credit || "0",
//       sortable: true,
//       width: "20%",
//     },
// {
//   name: "Status",
//   cell: (row: Customer) => (
//     <span
//       className={`badge rounded-pill ${
//         row.is_active === 1 ? "bg-success" : "bg-danger"
//       }`}
//     >
//       {row.is_active === 1 ? "Enable" : "Disable"}
//     </span>
//   ),
//   width: "20%",
// },
//     {
//       name: "Actions",
//       cell: (row: Customer) => (
//         <div className="d-flex justify-content-between">
// <Button
//   color={row.is_active ? "success" : "secondary"}
//   size="sm"
//   onClick={() => toggleEnable(row.id, row.is_active)}
//   disabled={disabledEnable === row.id || disableAllEnable}
//   style={{
//     marginRight: "5px",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//   }}
//   title={row.is_active ? "Disable" : "Enable"}
// >
//   <i
//     className={`fa ${row.is_active ? "fa-check-circle" : "fa-ban"}`}
//   />
// </Button>
//           <Button
//             color="info"
//             size="sm"
//             onClick={() => handlecustomerhistory(row.id)}
//             style={{
//               marginRight: "5px",
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//             }}
//             title="View Call History"
//           >
//             <i className="fa fa-phone" />
//           </Button>
//           <Button
//             color="secondary"
//             size="sm"
//             onClick={() => handlePackageHistory(row.id)} // Call your handler for package history
//             style={{
//               marginRight: "5px",
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//             }}
//             title="View Package Bought"
//           >
//             <i className="fa fa-cube" /> {/* Icon for the button */}
//           </Button>
//         </div>
//       ),
//       ignoreRowClick: true,
//       allowOverflow: true,
//       // button: true,
//       width:"20%"
//     }
//   ];

//   const customStyles = {
//     headCells: {
//       style: {
//         fontSize: "16px",
//         fontWeight: "600",
//         color: "#308e87",
//         backgroundColor: "#f8f9fa",
//         borderBottom: "2px solid #308e87",
//       },
//     },
//     rows: {
//       style: {
//         borderBottom: "1px solid #dee2e6",
//       },
//     },
//     table: {
//       style: {
//         border: "1px solid #dee2e6",
//         borderRadius: "8px",
//       },
//     },
//   };

//   if (loading) {
//     return (
//       <div
//         style={{
//           display: "flex",
//           justifyContent: "center",
//           alignItems: "center",
//           height: "100vh",
//         }}
//       >
//         <Spinner color="primary" />
//       </div>
//     );
//   }

//   return (
//     <>
//       <div className="page-body">
//         <Breadcrumbs
//           pageTitle={ViewCustomerTitle}
//           parent={CustomerTitle}
//           title={ViewCustomerTitle}
//         />
//         <Col xl={12} className="mb-lg-3">
//           <Card>
//             <CardBody>
//               <div className="mb-3">
//                 <FilterComponent
//                   onFilter={(e: React.ChangeEvent<HTMLInputElement>) =>
//                     setFilterText(e.target.value)
//                   }
//                   filterText={filterText}
//                 />
//               </div>
//               <div className="table-responsive custom-scrollbar">
//                 <DataTable
//                   data={filteredItems}
//                   columns={customerTableColumns}
//                   highlightOnHover
//                   striped
//                   customStyles={customStyles}
//                   pagination={filterText.trim() === ""}
//                   paginationServer={filterText.trim() === ""}
//                   paginationPerPage={perPage}
//                   paginationTotalRows={totalRows}
//                   onChangePage={handlePageChange}
//                   onChangeRowsPerPage={handlePerRowsChange}
//                   paginationDefaultPage={currentPage}
//                   responsive
//                 />
//               </div>
//             </CardBody>
//           </Card>
//         </Col>
//         <ToastContainer />
//       </div>
//     </>
//   );
// }

// // ////pagination and search works but flicker and search pointer disappear
// import React, { useState, useEffect } from "react";
// import { Card, CardBody, Col, Button, Spinner } from "reactstrap";
// import DataTable from "react-data-table-component";
// import { CustomerTitle, ViewCustomerTitle } from "../../../Utils/Constants";
// import Breadcrumbs from "../../../CommonElements/Breadcrumbs";
// import axios from "axios";
// import { baseUrl } from "../../../Utils/FileUpload";
// import FilterComponent from "../../../Components/Tables/DataTables/Common/FilterComponent";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import { useNavigate } from "react-router-dom";
// import { useDebounce } from "use-debounce";
// interface Customer {
//   id: string;
//   mobile: number;
//   is_active: number;
//   credit: number;
// }
// export default function Customer() {
//   const [filterText, setFilterText] = useState("");
//   const [debouncedFilterText] = useDebounce(filterText, 1500);
//   const [filteredItems, setFilteredItems] = useState<Customer[]>([]);
//   const token = localStorage.getItem("token");
//   const navigate = useNavigate();
//   const [totalRows, setTotalRows] = useState<number>(0);
//   const [perPage, setPerPage] = useState<number>(10);
//   const [currentPage, setCurrentPage] = useState<number>(1);
//   const [loading, setLoading] = useState(true);
//   const [disabledEnable, setDisabledEnable] = useState<string | null>(null);
//   const [disableAllEnable, setDisableAllEnable] = useState(false);
//   const [refresh, setRefresh] = useState(0);

//   const fetchData = async (page = 1, perPage = 10, search = "") => {
//     try {
//       setLoading(true);
//       const response = await axios.get(`${baseUrl}customer_detail/getall`, {
//         params: {
//           page,
//           per_page: perPage,
//           search: search.trim() !== "" ? search : undefined,
//         },
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       });

//       const data: Customer[] = response.data.data;
//       setFilteredItems(data);
//       setTotalRows(response.data.total);
//       setCurrentPage(response.data.current_page);
//     } catch (error) {
//       console.error("Error fetching data:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchData(currentPage, perPage);
//   }, [currentPage, perPage]);

//   useEffect(() => {
//     if (debouncedFilterText.trim() !== "") {
//       fetchData(1, perPage, debouncedFilterText); // Search API call
//     } else {
//       fetchData(currentPage, perPage); // Paginated API call
//     }
//   }, [debouncedFilterText]);
//   const handlePageChange = (page: number) => {
//     if (filterText.trim() === "") {
//       setCurrentPage(page);
//       fetchData(page, perPage);
//     }
//   };

//   const handlePerRowsChange = async (newPerPage: number, page: number) => {
//     setPerPage(newPerPage);
//     setCurrentPage(1);
//     if (filterText.trim() === "") {
//       await fetchData(1, newPerPage);
//     }
//   };

//   const filteredData = filteredItems.filter((item) => {
//     return (
//       (item.mobile &&
//         item.mobile.toString().includes(filterText.toLowerCase())) ||
//       (item.credit && item.credit.toString().includes(filterText.toLowerCase()))
//     );
//   });

//   const handlePackageHistory = (id: string) => {
//     navigate("/package_bought", { state: { id: id } });
//   };

//   const handlecustomerhistory = (id: string) => {
//     navigate("/call_history", { state: { customer_id: id } });
//   };

//   const toggleEnable = (id: string, currentStatus: number) => {
//     setDisabledEnable(id);
//     setDisableAllEnable(true);

//     const confirmToggleEnable = async (id: string, currentStatus: number) => {
//       setDisabledEnable(null);
//       setDisableAllEnable(false);

//       try {
//         const newStatus = currentStatus === 1 ? 0 : 1;

//         await axios.post(
//           `${baseUrl}customer_detail/toggle_active`,
//           { id, is_active: newStatus },
//           {
//             headers: {
//               "Content-Type": "application/json",
//               Authorization: `Bearer ${token}`,
//             },
//           }
//         );

//         toast.success(
//           `Customer ${newStatus === 1 ? "enabled" : "disabled"} successfully!`,
//           {
//             position: "top-right",
//             autoClose: 1000,
//             closeOnClick: true,
//             onClose: () => {
//               setRefresh((prev) => prev + 1);
//             },
//           }
//         );
//       } catch (error) {
//         console.error("Error toggling customer:", error);
//         toast.error("Error updating enable status", {
//           position: "top-right",
//           autoClose: 1000,
//         });
//       }
//     };

//     // ✅ Use function-based content for toast
//     toast.warn(
//       ({ closeToast }) => (
//         <div>
//           <div>
//             Are you sure you want to{" "}
//             <strong>{currentStatus === 1 ? "disable" : "enable"}</strong> this
//             customer?
//           </div>
//           <div className="d-flex justify-content-end mt-2">
//             <Button
//               color={currentStatus === 1 ? "danger" : "success"}
//               onClick={() => {
//                 confirmToggleEnable(id, currentStatus);
//                 closeToast();
//               }}
//             >
//               Yes
//             </Button>
//             <Button
//               color="secondary"
//               onClick={() => {
//                 setDisabledEnable(null);
//                 setDisableAllEnable(false);
//                 closeToast();
//               }}
//               className="ms-2"
//             >
//               Cancel
//             </Button>
//           </div>
//         </div>
//       ),
//       {
//         position: "top-right",
//         autoClose: false,
//         closeOnClick: false,
//         closeButton: false,
//         draggable: false,
//         onClose: () => {
//           setDisabledEnable(null);
//           setDisableAllEnable(false);
//         },
//       }
//     );
//   };

//   // Define columns with actions
//   const customerTableColumns = [
//     {
//       name: "S.No",
//       cell: (row: Customer, index: number) => (
//         <>{(currentPage - 1) * perPage + index + 1}</>
//       ),
//       width: "20%",
//     },
//     {
//       name: "Customer Mobile",
//       selector: (row: Customer) => row.mobile || "N/A",
//       sortable: true,
//       width: "20%",
//     },
//     {
//       name: "Credit Remaining",
//       selector: (row: Customer) => row.credit || "0",
//       sortable: true,
//       width: "20%",
//     },
//     {
//       name: "Status",
//       cell: (row: Customer) => (
//         <span
//           className={`badge rounded-pill ${
//             row.is_active === 1 ? "bg-success" : "bg-danger"
//           }`}
//         >
//           {row.is_active === 1 ? "Enable" : "Disable"}
//         </span>
//       ),
//       // sortable: true,
//       width: "20%",
//     },
//     {
//       name: "Actions",
//       cell: (row: Customer) => (
//         <div className="d-flex justify-content-between">
//           <Button
//             color={row.is_active ? "success" : "secondary"}
//             size="sm"
//             onClick={() => toggleEnable(row.id, row.is_active)}
//             disabled={disabledEnable === row.id || disableAllEnable}
//             style={{
//               marginRight: "5px",
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//             }}
//             title={row.is_active ? "Disable" : "Enable"}
//           >
//             <i
//               className={`fa ${row.is_active ? "fa-check-circle" : "fa-ban"}`}
//             />
//           </Button>
//           <Button
//             color="info"
//             size="sm"
//             onClick={() => handlecustomerhistory(row.id)}
//             style={{
//               marginRight: "5px",
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//             }}
//             title="View Call History"
//           >
//             <i className="fa fa-phone" />
//           </Button>
//           <Button
//             color="secondary"
//             size="sm"
//             onClick={() => handlePackageHistory(row.id)} // Call your handler for package history
//             style={{
//               marginRight: "5px",
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//             }}
//             title="View Package Bought"
//           >
//             <i className="fa fa-cube" /> {/* Icon for the button */}
//           </Button>
//         </div>
//       ),
//       ignoreRowClick: true,
//       allowOverflow: true,
//       // button: true,
//       width: "20%",
//     },
//   ];

//   const customStyles = {
//     headCells: {
//       style: {
//         fontSize: "16px",
//         fontWeight: "600",
//         color: "#308e87",
//         backgroundColor: "#f8f9fa",
//         borderBottom: "2px solid #308e87",
//       },
//     },
//     rows: {
//       style: {
//         borderBottom: "1px solid #dee2e6",
//       },
//     },
//     table: {
//       style: {
//         border: "1px solid #dee2e6",
//         borderRadius: "8px",
//       },
//     },
//   };

//   // Show a loading spinner while data is being fetched
//   if (loading) {
//     return (
//       <div
//         style={{
//           display: "flex",
//           justifyContent: "center",
//           alignItems: "center",
//           height: "100vh",
//         }}
//       >
//         <Spinner color="primary" />
//       </div>
//     );
//   }

//   return (
//     <>
//       <div className="page-body">
//         <Breadcrumbs
//           pageTitle={ViewCustomerTitle}
//           parent={CustomerTitle}
//           title={ViewCustomerTitle}
//         />
//         <Col xl={12} className="mb-lg-3">
//           <Card>
//             <CardBody>
//               <div className="mb-3">
//                 <FilterComponent
//                   onFilter={(e) => setFilterText(e.target.value)}
//                   filterText={filterText}
//                 />
//               </div>
//               <div className="table-responsive custom-scrollbar">
//                 <DataTable
//                   data={filteredData}
//                   columns={customerTableColumns}
//                   highlightOnHover
//                   striped
//                   customStyles={customStyles}
//                   pagination // ← enables pagination
//                   paginationServer // ← enables server-side pagination
//                   paginationPerPage={perPage} // ← sets how many rows per page
//                   paginationTotalRows={totalRows} // ← sets total count (e.g. 55)
//                   onChangePage={handlePageChange} // ← handles page click
//                   onChangeRowsPerPage={handlePerRowsChange} // ← handles per page change
//                   paginationDefaultPage={currentPage}
//                   responsive
//                 />
//               </div>
//             </CardBody>
//           </Card>
//         </Col>
//         <ToastContainer />
//       </div>
//     </>
//   );
// }

////pagination works but search wont
// import React, { useState, useEffect } from "react";
// import { Card, CardBody, Col, Button, Spinner } from "reactstrap";
// import DataTable from "react-data-table-component";
// import { CustomerTitle, ViewCustomerTitle } from "../../../Utils/Constants";
// import Breadcrumbs from "../../../CommonElements/Breadcrumbs";
// import axios from "axios";
// import { baseUrl } from "../../../Utils/FileUpload";
// import FilterComponent from "../../../Components/Tables/DataTables/Common/FilterComponent";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import { useNavigate } from "react-router-dom";

// interface Customer {
//   id: string;
//   mobile: number;
//   is_active: number;
//   credit: number;
// }
// export default function Customer() {
//   const [filterText, setFilterText] = useState("");
//   const [filteredItems, setFilteredItems] = useState<Customer[]>([]);
// const [refresh, setRefresh] = useState(0);
//   const token = localStorage.getItem("token");
//   const navigate = useNavigate();
// const [disabledEnable, setDisabledEnable] = useState<string | null>(null);
// const [disableAllEnable, setDisableAllEnable] = useState(false);
//   const [totalRows, setTotalRows] = useState<number>(0);
//   const [perPage, setPerPage] = useState<number>(10);
//   const [currentPage, setCurrentPage] = useState<number>(1);
//   const [loading, setLoading] = useState(true);

//   const fetchData = async (page = 1, perPage = 10) => {
//     try {
//       setLoading(true);
//       const response = await axios.get(`${baseUrl}customer_detail/getall`, {
//         params: {
//           page,
//           per_page: perPage,
//         },
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       });
//       // console.log(response.data);

//       const data: Customer[] = response.data.data;
//       setFilteredItems(data);
//       setTotalRows(response.data.total);
//       setCurrentPage(response.data.current_page);
//       setLoading(false);
//     } catch (error) {
//       console.error("Error fetching data:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchData(currentPage, perPage);
//   }, [currentPage, perPage]);

//   const handlePageChange = (page: number) => {
//     setCurrentPage(page);
//   };

//   const handlePerRowsChange = async (newPerPage: number, page: number) => {
//     console.log(newPerPage, page);
//     setPerPage(newPerPage);
//     setCurrentPage(1);
//     await fetchData(1, newPerPage);
//   };

//   const filteredData = filteredItems.filter((item) => {
//     return (
//       (item.mobile &&
//         item.mobile.toString().includes(filterText.toLowerCase())) ||
//       (item.credit && item.credit.toString().includes(filterText.toLowerCase()))
//     );
//   });

// const toggleEnable = (id: string, currentStatus: number) => {
//   setDisabledEnable(id);
//   setDisableAllEnable(true);

//   const confirmToggleEnable = async (id: string, currentStatus: number) => {
//     setDisabledEnable(null);
//     setDisableAllEnable(false);

//     try {
//       const newStatus = currentStatus === 1 ? 0 : 1;

//       await axios.post(
//         `${baseUrl}customer_detail/toggle_active`,
//         { id, is_active: newStatus },
//         {
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${token}`,
//           },
//         }
//       );

//       toast.success(
//         `Customer ${newStatus === 1 ? "enabled" : "disabled"} successfully!`,
//         {
//           position: "top-right",
//           autoClose: 1000,
//           closeOnClick: true,
//           onClose: () => {
//             setRefresh((prev) => prev + 1);
//           },
//         }
//       );
//     } catch (error) {
//       console.error("Error toggling customer:", error);
//       toast.error("Error updating enable status", {
//         position: "top-right",
//         autoClose: 1000,
//       });
//     }
//   };

//   // ✅ Use function-based content for toast
//   toast.warn(
//     ({ closeToast }) => (
//       <div>
//         <div>
//           Are you sure you want to{" "}
//           <strong>{currentStatus === 1 ? "disable" : "enable"}</strong> this
//           customer?
//         </div>
//         <div className="d-flex justify-content-end mt-2">
//           <Button
//             color={currentStatus === 1 ? "danger" : "success"}
//             onClick={() => {
//               confirmToggleEnable(id, currentStatus);
//               closeToast();
//             }}
//           >
//             Yes
//           </Button>
//           <Button
//             color="secondary"
//             onClick={() => {
//               setDisabledEnable(null);
//               setDisableAllEnable(false);
//               closeToast();
//             }}
//             className="ms-2"
//           >
//             Cancel
//           </Button>
//         </div>
//       </div>
//     ),
//     {
//       position: "top-right",
//       autoClose: false,
//       closeOnClick: false,
//       closeButton: false,
//       draggable: false,
//       onClose: () => {
//         setDisabledEnable(null);
//         setDisableAllEnable(false);
//       },
//     }
//   );
// };

//   const handlePackageHistory = (id: string) => {
//     navigate("/package_bought", { state: { id: id } });
//   };

//   const handlecustomerhistory = (id: string) => {
//     navigate("/call_history", { state: { customer_id: id } });
//   };

//   // Define columns with actions
//   const customerTableColumns = [
//     {
//       name: "S.No",
//       cell: (row: Customer, index: number) => (
//         <>{(currentPage - 1) * perPage + index + 1}</>
//       ),
//       width: "20%",
//     },
//     {
//       name: "Customer Mobile",
//       selector: (row: Customer) => row.mobile || "N/A",
//       sortable: true,
//       width: "20%",
//     },
//     {
//       name: "Credit Remaining",
//       selector: (row: Customer) => row.credit || "0",
//       sortable: true,
//       width: "20%",
//     },
//     {
//       name: "Status",
//       cell: (row: Customer) => (
//         <span
//           className={`badge rounded-pill ${
//             row.is_active === 1 ? "bg-success" : "bg-danger"
//           }`}
//         >
//           {row.is_active === 1 ? "Enable" : "Disable"}
//         </span>
//       ),
//       // sortable: true,
//       width: "20%",
//     },
// {
//   name: "Actions",
//   cell: (row: Customer) => (
//     <div className="d-flex justify-content-between">
//       <Button
//         color={row.is_active ? "success" : "secondary"}
//         size="sm"
//         onClick={() => toggleEnable(row.id, row.is_active)}
//         disabled={disabledEnable === row.id || disableAllEnable}
//         style={{
//           marginRight: "5px",
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "center",
//         }}
//         title={row.is_active ? "Disable" : "Enable"}
//       >
//         <i
//           className={`fa ${row.is_active ? "fa-check-circle" : "fa-ban"}`}
//         />
//       </Button>
//       <Button
//         color="info"
//         size="sm"
//         onClick={() => handlecustomerhistory(row.id)}
//         style={{
//           marginRight: "5px",
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "center",
//         }}
//         title="View Call History"
//       >
//         <i className="fa fa-phone" />
//       </Button>
//       <Button
//         color="secondary"
//         size="sm"
//         onClick={() => handlePackageHistory(row.id)} // Call your handler for package history
//         style={{
//           marginRight: "5px",
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "center",
//         }}
//         title="View Package Bought"
//       >
//         <i className="fa fa-cube" /> {/* Icon for the button */}
//       </Button>
//     </div>
//   ),
//   ignoreRowClick: true,
//   allowOverflow: true,
//   // button: true,
//   width: "20%",
// },
//   ];

//   const customStyles = {
//     headCells: {
//       style: {
//         fontSize: "16px",
//         fontWeight: "600",
//         color: "#308e87",
//         backgroundColor: "#f8f9fa",
//         borderBottom: "2px solid #308e87",
//       },
//     },
//     rows: {
//       style: {
//         borderBottom: "1px solid #dee2e6",
//       },
//     },
//     table: {
//       style: {
//         border: "1px solid #dee2e6",
//         borderRadius: "8px",
//       },
//     },
//   };

//     // Show a loading spinner while data is being fetched
//     if (loading) {
//       return (
//         <div
//           style={{
//             display: "flex",
//             justifyContent: "center",
//             alignItems: "center",
//             height: "100vh",
//           }}
//         >
//           <Spinner color="primary" />
//         </div>
//       );
//     }

//   return (
//     <>
//       <div className="page-body">
//         <Breadcrumbs
//           pageTitle={ViewCustomerTitle}
//           parent={CustomerTitle}
//           title={ViewCustomerTitle}
//         />
//         <Col xl={12} className="mb-lg-3">
//           <Card>
//             <CardBody>
//               <div className="mb-3">
//                 <FilterComponent
//                   onFilter={(e: React.ChangeEvent<HTMLInputElement>) =>
//                     setFilterText(e.target.value)
//                   }
//                   filterText={filterText}
//                 />
//               </div>
//               <div className="table-responsive custom-scrollbar">
//                 <DataTable
//                   data={filteredData}
//                   columns={customerTableColumns}
//                   highlightOnHover
//                   striped
//                   customStyles={customStyles}
//                   pagination // ← enables pagination
//                   paginationServer // ← enables server-side pagination
//                   paginationPerPage={perPage} // ← sets how many rows per page
//                   paginationTotalRows={totalRows} // ← sets total count (e.g. 55)
//                   onChangePage={handlePageChange} // ← handles page click
//                   onChangeRowsPerPage={handlePerRowsChange} // ← handles per page change
//                   paginationDefaultPage={currentPage}
//                   responsive
//                 />
//               </div>
//             </CardBody>
//           </Card>
//         </Col>
//         <ToastContainer />
//       </div>
//     </>
//   );
// }
